import moment from 'moment-timezone'

moment.defineLocale('en-ag', {
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ],
  monthsShort: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ],
  weekdays: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ],
  weekdaysShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  weekdaysMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'],
  longDateFormat: {
    LT: 'hh:mm', // Time format (e.g., 10:30 PM)
    LTS: 'hh:mm:ss', // Time with seconds (e.g., 10:30:30 PM)
    L: 'DD/MM/YYYY', // Date format (e.g., 30/12/2024)
    LL: 'D MMMM, YYYY', // Long date (e.g., 30 December, 2024)
    LLL: 'D MMMM, YYYY hh:mm A', // Long date and time (e.g., 30 December, 2024 10:30 PM)
    LLLL: 'dddd, D MMMM, YYYY hh:mm A' // Full long date and time (e.g., Monday, 30 December, 2024 10:30 PM),
  },
  relativeTime: {
    future: 'in %s', // Future times
    past: '%s ago', // Past times
    s: 'a few seconds', // Few seconds
    m: 'a minute', // Minute
    mm: '%d minutes', // Minutes
    h: 'an hour', // Hour
    hh: '%d hours', // Hours
    d: 'a day', // Day
    dd: '%d days', // Days
    M: 'a month', // Month
    MM: '%d months', // Months
    y: 'a year', // Year
    yy: '%d years' // Years
  }
})
